import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import { useCurrentProject } from '../../../contexts/settings';
import { usePaths } from '../../../routes/routesHelper';
import { RouteParams } from '../../../routes/types';
import { NavigationWrapper } from '../../ui';

type Props = React.PropsWithChildren<RouteComponentProps>;

const LegalSettingsTabs = ({ match, children }: Props): JSX.Element => {
  const { ageRestrictionsPath, dashboardPath, navigationPath, termsAndPoliciesLegalSettingsPath } =
    usePaths();
  const { projectId } = match.params as RouteParams;
  const intl = useIntl();
  const { currentProject } = useCurrentProject(projectId);

  const tabItems = [
    {
      label: intl.formatMessage({ id: 'legal-settings.tabs.terms-and-policies' }),
      href: termsAndPoliciesLegalSettingsPath(projectId)
    },
    {
      label: intl.formatMessage({ id: 'legal-settings.tabs.age-restrictions' }),
      href: ageRestrictionsPath(projectId)
    }
  ];

  const breadCrumbsOptions = [
    {
      label: intl.messages['dashboard.label'],
      to: dashboardPath()
    },
    {
      label: currentProject?.name,
      to: navigationPath(projectId)
    },
    {
      label: intl.messages['legal-settings.breadcrumb.label'],
      to: `#`
    }
  ];

  return (
    <NavigationWrapper
      breadCrumbsOptions={breadCrumbsOptions}
      tabsItems={tabItems}
      dataTestId="customization-settings">
      {children}
    </NavigationWrapper>
  );
};

export default withRouter(LegalSettingsTabs);
